// Structure extensible : chaque prestation possède un id, un titre,
// un résumé, un état (active) et un détail. Une prestation inactive
// s'affiche avec la mention "Bientôt" — prête à être activée plus tard.
export const services = [
  {
    id: "peinture-interieure",
    titre: "Peinture intérieure décorative",
    active: true,
    resume:
      "Murs, plafonds, boiseries : des finitions impeccables et des teintes qui donnent du caractère à votre intérieur.",
    description:
      "C'est le cœur du métier d'Alexis Peinture. Chaque pièce est préparée, protégée puis peinte avec une exigence de finition constante : lignes nettes, surfaces lisses, teintes fidèles à votre projet.",
    points: [
      "Préparation minutieuse des supports (rebouchage, ponçage, sous-couche)",
      "Protection complète des sols, meubles et menuiseries",
      "Peintures de qualité professionnelle, teintes conseillées sur place",
      "Finitions soignées : raccords invisibles, arêtes propres, chantier rangé",
    ],
  },
  {
    id: "peinture-exterieure",
    titre: "Peinture extérieure",
    active: false,
    resume: "Volets, portails, menuiseries extérieures et murs exposés aux intempéries.",
  },
  {
    id: "ravalement",
    titre: "Ravalement de façade",
    active: false,
    resume: "Nettoyage, réparation et mise en peinture des façades pour redonner vie à votre maison.",
  },
  {
    id: "papier-peint",
    titre: "Pose de papier peint",
    active: false,
    resume: "Pose précise de papiers peints classiques ou panoramiques, raccords parfaits.",
  },
  {
    id: "enduits",
    titre: "Enduits & préparation",
    active: false,
    resume: "Enduits de réparation et de lissage pour des supports parfaitement préparés.",
  },
];
